import "/src/style/main.scss"

import AOS from 'aos';
AOS.init({
    offset: 100,
    duration: 600,
    delay: 100,
    once: true,
});

// Other
import "./functions";

// Modules
import SiteHeader from "./modules/site-header";
SiteHeader().init()

import SiteNav from "./modules/site-nav";
SiteNav().init()

import SiteNavMobile from "./modules/site-nav-mobile";
SiteNavMobile().init()

import Slider from "./modules/slider";
Slider().init()

import Accordions from "./modules/accordions";
Accordions().init()

// Templates
import About from "./templates/about";
About().init()

import Events from "./templates/events";
Events().init()

import Opportunities from "./templates/opportunities";
Opportunities().init()

import News from "./templates/news";
News().init()

import FrontPage from "./front-page";
FrontPage().init()


// Template parts

// Pages
